const animationPlayerObject = {
    status: 1,
    arrayAnimation: [],
    arrayImage: [],
    handlers: {},
    initialize: function () {

    },
    isExistAnimation: function (name) {
        return typeof this.arrayAnimation[name] !== 'undefined';
    },
    play: function (name, direction) {
        const animation = this.arrayAnimation[name];

        if (animation.direction !== direction) {
            animation.direction = direction;
            if (!animation.playing) {//Если нужно чтобы время не сбрасывалось и обратная анимация пыталась уложиться в отведенной время
                animation.startTime = performance.now();
            } else {
                const d = performance.now() - animation.startTime; // Сколько уже шла анимация
                const o = animation.duration - d; // Сколько осталось от анимации
                animation.startTime = performance.now() - o;
            }
            animation.playing = true;

            this.nextFrame(name);

            this.fireEvent('before', animation.direction, name);
        }
    },
    nextFrame: function (name) {
        const animation = this.arrayAnimation[name];
        const timeOfAnimation = performance.now() - animation.startTime;

        let frame = Math.min(
            animation.lastFrame,
            Math.ceil((timeOfAnimation / (animation.direction === 'forward' ? animation.duration : animation.duration / animation.reverseAcceleration)) * (animation.lastFrame + 1))
        );

        if (animation.direction === 'backward') frame = animation.lastFrame - frame;

        if (animation.currentFrame !== frame && typeof animation.frames[frame] !== 'undefined') {
            this.drawFrame(animation, frame);
        }

        if (
            (animation.direction === 'forward' && frame === animation.lastFrame)
            ||
            (animation.direction === 'backward' && frame === 0)
        ) {
            animation.playing = false;
            this.fireEvent('after', animation.direction, name);
            return;
        }

        requestAnimationFrame(this.nextFrame.bind(this, name));
    },
    register: function (config) {
        if (typeof config.canvas === 'undefined') return;
        const canvas = config.canvas;

        if (typeof config.arrayImage === 'undefined') return;
        const arrayImage = config.arrayImage;

        const reverseAcceleration = typeof config.reverseAcceleration === 'undefined' ? 1 : config.reverseAcceleration;

        const initFrame = typeof config.initFrame === 'undefined' ? null : parseInt(config.initFrame);

        const name = config.name;
        if (typeof name === 'undefined' || this.isExistAnimation(name)) return;

        this.status = -1;

        let duration = config.duration;

        this.arrayImage[name] = [];
        this.arrayAnimation[name] = {
            isPlaying: false,
            lastFrame: arrayImage.length - 1,
            canvas: canvas,
            frames: [],
            duration: duration,
            direction: null,
            currentFrame: 0,
            startTime: 0,
            reverseAcceleration: reverseAcceleration,
            initFrame: initFrame
        };

        for (let i = 0; i <= arrayImage.length - 1; i++) {
            this.arrayImage[name][arrayImage[i]] = null;

            const img = new Image();
            img.src = arrayImage[i];
            img.onload = () => {
                main.setLoaderPercent(1);
                this.arrayImage[name][arrayImage[i]] = img;
                this.checkStatusLoad();
            }
        }
    },
    checkStatusLoad: function () {
        let isAllLoad = true;
        Object.entries(this.arrayImage).forEach(([name, images]) => {
            Object.keys(images).forEach((src) => {
                if (images[src] === null) isAllLoad = false;
            });

            if (isAllLoad) {
                Object.keys(images).forEach((src) => {
                    this.arrayAnimation[name].frames.push(images[src]);
                });
                this.arrayAnimation[name].canvas.width = this.arrayAnimation[name].frames[0].width;
                this.arrayAnimation[name].canvas.height = this.arrayAnimation[name].frames[0].height;

                if (this.arrayAnimation[name].initFrame !== null) {
                    this.drawFrame(this.arrayAnimation[name], this.arrayAnimation[name].initFrame);
                }

                delete this.arrayImage[name];
            }
        });

        if (isAllLoad) this.status = 1;
    },
    drawFrame: function (animation, frame) {
        animation.currentFrame = frame;
        animation.canvas.getContext("2d").drawImage(animation.frames[frame], 0, 0);
    },
    fireEvent: function (eventTime, animationDirection, animationName) {
        if (typeof this.handlers[animationName] === 'undefined') this.handlers[animationName] = [];

        this.handlers[animationName].forEach((item) => {
            new Promise(() => item.f.call(item.s, eventTime, animationName, animationDirection)).catch((error) => console.log(error));
        });
    },
    subscribeOnEvent: function (animationName, functionName, thisObj) {
        if (typeof this.arrayAnimation[animationName] === 'undefined') return;
        let scope = thisObj || window;
        if (typeof this.handlers[animationName] === 'undefined') this.handlers[animationName] = [];
        this.handlers[animationName].push({
            'f': functionName,
            's': scope
        });
    }
};
